import { colors, styled, SearchField as ComponentsSearchField } from "@tm/components"

export const SearchField = styled(ComponentsSearchField)({
    width: 350,
    ".MuiInputBase-root": {
        borderColor: colors.grey[400],
    },
})
